import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageNWSL4 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Denver Signs Jasmine Aikey",
            author: "footballgirl",
              date: "January, 2026",
            image: "images/nwsl/4a.jpg",
            content: `<h2>Denver Summit FC Signs Stanford Star Jasmine Aikey </h2>

<p>Denver Summit FC, one of the National Women's Soccer League's
(NWSL) two expansion franchises debuting in the 2026 season 
alongside Boston Legacy FC, has made a major splash by 
signing Stanford University standout Jasmine Aikey.</p>
 
<p>Announced on January 8, 2026, 
 the forward joins the club on a 
 two-year contract through the 2027 season,
  with a mutual option for 2028.</p>
  
  <p> As a highly touted prospect ranked No. 1 in NCAA women's 
   soccer by TopDrawerSoccer entering the pros, 
   Aikey is positioned as a foundational piece
    for the Denver-based team's inaugural campaign.</p>

<h2>Jasmine Aikey's Stellar College Career</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
<p>A Palo Alto, California native and Stanford graduate with 
a degree in Computer Science, Jasmine Aikey (born July 7, 2005) 
wrapped up one of the most decorated careers in Stanford women's 
soccer history. Across four seasons from 2022 to 2025, she appeared 
in 89 games, tallying 43 goals and 29 assists for 115 points, ranking
 ninth all-time in program history for goals.</p>

<p>Her senior season in 2025 was particularly dominant: Aikey 
led the nation in several key attacking categories, scoring 
21 goals with 11 assists and seven game-winners while helping 
Stanford win the ACC Tournament and reach the NCAA Championship final.
</p><p>
 She claimed the 2025 MAC Hermann Trophy—the most prestigious 
 individual award in NCAA Division I women's soccer—becoming the
  sixth Stanford player to win it. </p>
  
  <p>Additional honors included TopDrawerSoccer Player of the Year, 
  United Soccer Coaches All-America first-team selection,
  and finalist for the Honda Sport Award for Soccer. 
  Aikey also contributed to three College Cup appearances during 
  her time with the Cardinal.</p>

<h2>Versatility and Playing Style</h2>
<p>Known for her versatility, Aikey excels as a 
forward capable of playing multiple attacking roles,
 including striker or attacking midfielder. </p>

 <p>She combines technical skill, vision for creating chances,
  composure under pressure, and a high soccer IQ.
   Coaches and teammates have praised her winning 
   mentality and intelligence on the field.</p>
   
   <p>Her decision to join an expansion team like Denver
    Summit FC stems from excitement about helping shape a
     new club's culture, as she highlighted the organization's 
     ambitious standards and long-term vision in post-signing comments.</p>

<h2>Impact on Denver Summit FC</h2>
<p>For Denver Summit FC, Aikey represents a marquee 
signing during the club's roster-construction phase.
 The expansion side has emphasized blending veteran 
 NWSL experience, free agents, and elite collegiate talent
 to build a competitive foundation from the start. </p>
 
 <p>This move follows other additions, such as NWSL veteran Jordan Baggett,
  and underscores a strategy focused on dynamic, goal-oriented attackers.
  Aikey, wearing number 12, is expected to anchor the forward 
  line and provide leadership as the team prepares for its
   first season, which begins in 
   March 2026—with an opening home match at
    Empower Field at Mile High against Bay FC later in the month.</p>

<h2>Looking Ahead</h2>
<p>At just 20 years old, Aikey transitions to 
the professional level after representing the
 United States at youth international levels
 and establishing herself as one of the top 
 talents to emerge from recent college soccer. 
 
 Her arrival adds significant firepower and star
  potential to Denver Summit FC as they aim to make an 
  immediate impact in the NWSL.</p> 
  
  <h2>丹佛 Summit FC 签下斯坦福球星 Jasmine Aikey 作为顶级选秀球员</h2>

<h2>引言</h2>
<p>丹佛 Summit FC 是国家女子足球联赛（NWSL）两支将于2026赛季首次亮相的扩张球队之一（另一支为波士顿 Legacy FC），通过签下斯坦福大学杰出球员 Jasmine Aikey 掀起巨大波澜。该签约于2026年1月8日宣布，前锋 Aikey 与俱乐部签订为期两年的合同，直至2027赛季，并带有2028年的互惠选择权。作为 TopDrawerSoccer 评定的进入职业联赛前 NCAA 女子足球排名第1的顶级前景球员，Aikey 被定位为这支丹佛球队首赛季的基础核心球员。</p>

<h2>Jasmine Aikey 辉煌的大学生涯</h2>
<p>来自加利福尼亚州帕洛阿尔托的 Jasmine Aikey（出生于2005年7月7日）是斯坦福大学计算机科学专业毕业生，她结束了斯坦福女子足球历史上最辉煌的职业生涯之一。从2022年至2025年的四个赛季，她出场89次，打进43球并送出29次助攻，总计115分，在球队历史进球榜上排名第九。</p>
<p>她在2025年大四赛季表现尤为出色：Aikey 在多项关键进攻数据上领跑全国，打进21球、11次助攻并贡献7次制胜球，帮助斯坦福赢得 ACC 锦标赛并闯入 NCAA 冠军决赛。她荣获2025年 MAC Hermann Trophy——NCAA Division I 女子足球最具声望的个人奖项，成为斯坦福第六位获奖者。此外，她还获得 TopDrawerSoccer 年度最佳球员、United Soccer Coaches 全美第一阵容，并入围 Honda Sport Award 足球奖决赛。在斯坦福期间，她帮助球队三次进入 College Cup。</p>

<h2>多面性和比赛风格</h2>
<p>Aikey 以多面性著称，她擅长担任前锋，能胜任包括中锋或进攻型中场在内的多种进攻角色。她融合了技术能力、创造机会的视野、在压力下的冷静以及高超的足球智商。教练和队友赞扬她的赢家心态和场上智慧。她选择加入丹佛 Summit FC 这样的扩张球队，源于对帮助塑造新俱乐部文化和长期愿景的兴奋，她在签约后评论中强调了球队的高标准和雄心勃勃的目标。</p>

<h2>对丹佛 Summit FC 的影响</h2>
<p>对于丹佛 Summit FC 而言，Aikey 是球队阵容构建阶段的标志性签约。
该扩张球队强调融合 NWSL 老将、自由球员和顶级大学人才，从第一天起建立竞争基础。
此举继签下 NWSL 老将 Jordan Baggett 等其他球员之后，进一步突显球队聚焦动态、</p><p>
进球导向型进攻手的策略。Aikey 将身披12号球衣，预计将成为前锋线的支柱并提供领导力，
随着球队备战首赛季——2026年3月开始，主场首秀将在 Empower Field at Mile High 对阵 Bay FC（稍后于当月）。</p>

<h2>展望未来</h2>
<p>年仅20岁的 Aikey 在代表美国青年国家队后，转战职业联赛，并确立了自己作为近年来大学足球顶级天才之一的地位。她的加盟为丹佛 Summit FC 增添了显著的火力和明星潜力，帮助球队在 NWSL 中立即产生影响。</p>`,
            tags: ["NWSL", "Denver Summit FC", "Jasmine Aikey", "Transfers", "Stanford"],
            navIndices: { prev: 'nwsl-3', next: 'nwsl-5' }
        });
    }

    init() {
        console.log('ArticlePageNWSL4 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to NWSL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'nwsl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_nwsl.png';
            leagueLogo.alt = 'NWSL';
        }
    }
}